
import { Gift } from "lucide-react";
import { ReferralReward } from "@/hooks/useReferrals";
import RewardCard from "./RewardCard";

interface RewardsListProps {
  rewards: ReferralReward[];
  claimingRewards: Record<string, boolean>;
  onClaimReward: (rewardId: string) => void;
}

const RewardsList = ({ rewards, claimingRewards, onClaimReward }: RewardsListProps) => {
  if (rewards.length === 0) return null;
  
  return (
    <div className="mt-6">
      <h4 className="font-medium text-[#4A607B] mb-3 flex items-center">
        <Gift className="mr-2 h-4 w-4" />
        Your Rewards
      </h4>
      <div className="space-y-2">
        {rewards.map((reward) => (
          <RewardCard 
            key={reward.id}
            reward={reward}
            isClaimingReward={claimingRewards[reward.id] || false}
            onClaimReward={onClaimReward}
          />
        ))}
      </div>
    </div>
  );
};

export default RewardsList;
